import('../vue-shared').then(({default: vue, getInitData}) => {
  $(() => {
    const {mountPoint, initData} = getInitData('documentation');
    if (!mountPoint) {
      return;
    }

    vue.prototype.$documentationInitData = initData;

    import('./Documentation.vue').then(({default: component}) => {
      new vue({
        render: (h) => h(component),
        el: mountPoint,
      }).$mount();
    });
  });
});
